import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from "react-redux"

import { fetchMaterialBrands } from '../services/redux/reducers/commonThunk'
import { Tooltip } from 'primereact/tooltip'


const StructuredMaterialDisplay = (props) => {
    const { products } = props
    const materialBrands = useSelector((state) => state.common.materialBrands)

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(fetchMaterialBrands())
    }, [])

    return (
        <div style={{ }}>
            {products.length > 0 && (
                <div className='mb-2' style={{ textAlign: 'right', color: '', fontWeight: 'bold' }}>
                    No. of material matching with search filter: {products.length}
                </div>
            )}

            <div className='structured-product-preview product-preview-grid-container'>
                {products.length === 0 ? (
                    <div className="empty-state">No materials found for selected filters.</div>
                ) : (
                    products.map((eachProduct, index) => {
                        const relatedBrand = materialBrands.find(eachBrand => eachBrand.brandId === eachProduct.brandId)
                        return (
                            <div key={index} className="product-card">
                                <div className="top-row">
                                    <img
                                        src={
                                            eachProduct.materialImage?.[0] ??
                                            "https://procmart-tech.s3.ap-south-1.amazonaws.com/app-images/no_image.png"
                                        }
                                        alt={eachProduct.productName}
                                        className="product-img"
                                    />
                                    <div className="top-text">
                                        <div className='font-medium' style={{ fontSize: '13px', color: 'black' }}>
                                            {eachProduct.productName} - {relatedBrand?.brandName ?? 'N/A'}
                                        </div>
                                        <div style={{ fontSize: '12px', color: '#777' }}>
                                            {eachProduct.variantName}
                                        </div>
                                    </div>

                                </div>
                                <div className={`product-description custom-tooltip-specification-${eachProduct.materialId}`} style={{ fontSize :"11px"}}>
                                    {eachProduct.productSpecification}
                                </div>
                                <Tooltip target={`.custom-tooltip-specification-${eachProduct.materialId}`} position="top" autoHide>
                                    {eachProduct.productSpecification}
                                </Tooltip>
                            </div>
                        )
                    })
                )}
            </div>
        </div>
    )
}

export default StructuredMaterialDisplay
